import FastMarquee from "react-fast-marquee";

const ITEMS = [
  "Upstander Training",
  "Bystander Intervention",
  "Workplace Civility",
  "Conflict Reduction",
  "Speak-Up Culture",
  "Train-the-Trainer",
  "Psychological Safety",
];

export const Marquee = () => (
  <section className="overflow-hidden bg-navy py-8" aria-hidden="true" data-testid="keyword-marquee">
    <FastMarquee speed={32} gradient={false}>
      {ITEMS.map((item) => (
        <span key={item} className="mx-8 flex items-center gap-16 font-display text-3xl font-extrabold uppercase tracking-tight lg:text-4xl">
          <span className="text-cream">{item}</span>
          <span className="text-outline text-2xl lg:text-3xl">✦</span>
        </span>
      ))}
    </FastMarquee>
  </section>
);
